import React from 'react';
import Modal from 'react-modal';
import Row from '../tag/Row';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';
import modal from '../../definitions/Modal';
import { FormattedMessage } from 'react-intl';

const notificationModal = modal({ content: { width: '500px' } });

const HpaNotAllowedModal = (props) => {
  let { exitHpa, logout, ...rest } = props;
  return (
    <Modal {...rest} ariaHideApp={false} style={notificationModal}>
      <Row>
        <p>
          <FormattedMessage id="hpa.not.allowed" />
        </p>
      </Row>
      <Row>
        <OTButtonGroup fullWidth collapseOnMobile type="big">
          <OTButton key="cancel" onClick={exitHpa}>
            <FormattedMessage id="hpa.return" />
          </OTButton>

          <OTButton key="submit" onClick={logout}>
            <FormattedMessage id="sign.out" />
          </OTButton>
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

export default HpaNotAllowedModal;
